import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class EVPanelsService {
  private rightPanel = new Subject<boolean>();

  public setResultsPanelActive(active: boolean) {
    this.rightPanel.next(active);
  }
   
  public rightPanelPositionChange(): Observable<any> {
    return this.rightPanel.asObservable();
  }
}
